import React from "react"
import { useHistory } from "react-router-dom"
import { useTranslation, usePermissions } from "hooks"

import { translations } from "./translations"
import * as S from "./styles"
import { CommercialTeam } from "interfaces/commercial-team"

interface IGridCommercialTeamProps {
  commercialTeam: CommercialTeam[] | Record<string, any>[]
}

interface ICommercialTeamProps {
  team: CommercialTeam | Record<string, any>
}

const Item: React.FC<ICommercialTeamProps> = ({ team }) => {
  const history = useHistory()
  const { checkUserPermission } = usePermissions()
  // const havePermission = checkUserPermission("editCommercialTeam")
  const havePermission = true
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission && history.push(`/settings/commercial-team/${team.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{team.id}</S.ItemValue>
        <S.ItemValue>{team.erp_code}</S.ItemValue>
        <S.ItemValue>{team.role?.name}</S.ItemValue>
        <S.ItemValue>{team.name}</S.ItemValue>
        <S.ItemValue>{team.phone_number}</S.ItemValue>
        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  )
}

export const GridCommercialTeam: React.FC<IGridCommercialTeamProps> = ({
  commercialTeam = [],
}) => {
  const { getTranslation } = useTranslation(translations)

  return (
    <S.Container>
      <S.Header>
        <S.Label>{getTranslation("id")}</S.Label>
        <S.Label>{getTranslation("codigoSAP")}</S.Label>
        <S.Label>{getTranslation("commercialRole")}</S.Label>
        <S.Label>{getTranslation("name")}</S.Label>
        <S.Label>{getTranslation("phoneNumber")}</S.Label>

      </S.Header>
      {commercialTeam.length > 0 &&
        commercialTeam.map((team) => <Item team={team} key={team.id} />)}
    </S.Container>
  )
}
